import React from "react";
import "./loader.css";
const Loader = () => {
  return (
    <div className="loader">
      <h1 className="h1">Loading...</h1>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default Loader;
